<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-model-platform`]" width="1em" height="1em" v-bind="$attrs"><path d="M34.431 39.77l-9.251 4.87a1.825 1.825 0 01-1.18.39 1.825 1.825 0 01-1.18-.39l-9.252-4.87c-2.36-1.242-.496-4.782 1.864-3.54 2.36 1.242.496 4.782-1.864 3.54l-9.5-5c-2.36-1.242-.496-4.782 1.864-3.54l9.5 5L24 40.74l8.569-4.51c2.36-1.242 4.222 2.298 1.862 3.54l-1.862-3.54 1.862 3.54zm-20.862 0l1.862-3.54-1.862 3.54zm20.862-9l-9.251 4.87a1.825 1.825 0 01-1.18.39 1.825 1.825 0 01-1.18-.39l-9.252-4.87c-2.36-1.242-.496-4.782 1.864-3.54 2.36 1.242.496 4.782-1.864 3.54l-9.5-5c-2.36-1.242-.496-4.782 1.864-3.54l9.5 5L24 31.74l8.569-4.51c2.36-1.242 4.222 2.298 1.862 3.54l-1.862-3.54 1.862 3.54zm-20.862 0l1.862-3.54-1.862 3.54zm19-3.54l9.5-5c2.36-1.242 4.222 2.298 1.862 3.54l-9.5 5c-2.36 1.242-4.222-2.298-1.862-3.54zm0 9l9.5-5c2.36-1.242 4.222 2.298 1.862 3.54l-9.5 5c-2.36 1.242-4.222-2.298-1.862-3.54zM24.957 3.522l19.433 10.6a1 1 0 010 1.756l-19.433 10.6a2 2 0 01-1.916 0L3.61 15.877a1 1 0 010-1.756l19.433-10.6a2 2 0 011.916 0zM10.353 15L24 22.444 37.647 15 24 7.556 10.353 15z"/></svg>
</template>
<script>

export default {
  name: 'IconModelPlatform',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
